module.exports = __webpack_public_path__ + "assets/img/reminder-collate-11.6d8985e4.png";